import { PageCounterpartiesEdit } from './Edit';
import { PageCounterparties } from './Overview';

export const COUNTERPARTIES = {
  Counterparties: PageCounterparties,
  CounterpartiesEdit: PageCounterpartiesEdit,
} as const;
